var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var buttonElement = require('../components/button');
var flash = require('../components/flash');
var sharePointDelivery = require('./sharePointDelivery');

var state = {
  scheduledReportsFrom: prop(''),
  reportRetentionDays: prop(''),
  loaded: prop(false),
  loading: true,
  saving: false,
  message: prop([]),
  error: prop([])
};

function resetAlerts() {
  state.message([]);
  state.error([]);
}

function setMessage(items) {
  state.message(items);
}

function setError(items) {
  state.error(items);
}

function loadSettings() {
  resetAlerts();
  state.loaded(false);
  state.loading = true;
  return loaders.requestWithLoader({
    loader: 'main',
    method: 'GET',
    url: '/api/v1/notifications/settings',
  })
  .then(function (res) {
    if (!res || typeof res !== 'object') {
      setError(['Failed to load notification settings']);
      return;
    }
    state.scheduledReportsFrom(res.scheduledReportsFrom || '');
    state.reportRetentionDays(res.reportRetentionDays != null ? String(res.reportRetentionDays) : '');
    state.loaded(true);
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to load notification settings');
    setError([msg]);
  })
  .finally(function () {
    state.loading = false;
  });
}

function saveSettings() {
  resetAlerts();
  state.saving = true;
  var retentionValue = Number(state.reportRetentionDays());
  var normalizedRetention = Number.isFinite(retentionValue) && retentionValue > 0
    ? Math.round(retentionValue)
    : null;
  var payload = {
    scheduledReportsFrom: String(state.scheduledReportsFrom() || '').trim(),
    reportRetentionDays: normalizedRetention
  };
  return loaders.requestWithLoader({
    loader: 'submit',
    method: 'PUT',
    url: '/api/v1/notifications/settings',
    body: payload
  })
  .then(function (res) {
    if (res && typeof res === 'object') {
      state.scheduledReportsFrom(res.scheduledReportsFrom || payload.scheduledReportsFrom);
      if (typeof res.reportRetentionDays !== 'undefined' && res.reportRetentionDays !== null) {
        state.reportRetentionDays(String(res.reportRetentionDays));
      }
    }
    setMessage(['Saved report settings']);
  })
  .catch(function (err) {
    const msg = (err && err.message) ? err.message : (typeof err === 'string' ? err : 'Failed to save notification settings');
    setError([msg]);
  })
  .finally(function () {
    state.saving = false;
  });
}

var notificationsSettings = {
  oninit: function () {
    return loadSettings();
  },
  view: function () {
    var content = null;
    if (state.loading) {
      content = m('div.tc', [
        m('img.h1', { src: '/images/loading-bars.svg' })
      ]);
    } else if (state.loaded()) {
      content = m('div', [
        m('div.mb3', [
          m('label.db', 'Scheduled Reports From Address'),
          m('input.form-control.w-50-ns', {
            type: 'email',
            autocomplete: 'off',
            value: state.scheduledReportsFrom(),
            oninput: function (e) {
              state.scheduledReportsFrom(e.target.value);
            }
          }),
          m('div.f6.gray.mt1', 'Used for scheduled report delivery.')
        ]),
        m('div.mb3', [
          m('label.db', 'Report Retention (days)'),
          m('input.form-control.w-25-ns', {
            type: 'number',
            min: 1,
            step: 1,
            autocomplete: 'off',
            value: state.reportRetentionDays(),
            oninput: function (e) {
              state.reportRetentionDays(e.target.value);
            }
          }),
          m('div.f6.gray.mt1', 'Controls scheduled-report email link expiration and local report file cleanup. It does not delete SharePoint files or control the Downloads queue.')
        ]),
        m('div.mt2.flex.justify-end', [
          m(buttonElement, {
            label: state.saving ? 'Saving…' : 'Save',
            class: 'green',
            style: { minWidth: '33%' },
            func: saveSettings
          })
        ])
      ]);
    }
    return m('div', [
      m('h3.mt0', 'Reports'),
      state.error() && state.error().length ? m(flash, { items: state.error(), bg: 'bg-red' }) : null,
      state.message() && state.message().length ? m(flash, { items: state.message(), bg: 'bg-green' }) : null,
      content,
      m(sharePointDelivery)
    ]);
  }
};

module.exports = notificationsSettings;
